import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { connect } from 'react-redux';
import {
  primaryColorOrDefault,
  headerTextColorOrDefault,
  selectedRadiusOption,
  messagesFontFamily,
} from '../../reducers';
import styles from './Coupon.scss';
import CouponDivider from '../../icons/dist/components/couponDivider';
import CouponButton from './CouponButton';
import * as biLogger from '../../services/biLogger';
import { Message } from '@wix/chat-sdk';
import TitleBubble from '../TitleBubble';

interface CouponProps {
  i18nData: any;
  primaryColor: any;
  textHeaderColor: any;
  selectedRadiusOption: any;
  headerTitle: string;
  headerSubtitle: string;
  text: string;
  title?: string;
  fontFamily: string;
  message: Message;
}

interface CouponState {
  didCopied: boolean;
}

class Coupon extends React.Component<CouponProps, CouponState> {
  constructor(props) {
    super(props);
    this.state = {
      didCopied: false,
    };
  }

  handleCopy = () => {
    this.setState({ didCopied: true });
    biLogger.copyCouponCode();
    setTimeout(() => {
      this.setState({ didCopied: false });
    }, 4000);
  };

  render() {
    const {
      i18nData,
      primaryColor,
      textHeaderColor,
      headerTitle,
      headerSubtitle,
      text,
      fontFamily,
      message,
      title,
    } = this.props;
    const _selectedRadiusOption = this.props.selectedRadiusOption;

    const headerContainerAddedStyle = {
      backgroundColor: primaryColor,
      borderRadius: `${_selectedRadiusOption}px ${_selectedRadiusOption}px 0 0`,
      marginBottom: '-1px',
    };
    const textContainerAddedStyle = {
      backgroundColor: primaryColor,
      borderRadius: `0 0 ${_selectedRadiusOption}px ${_selectedRadiusOption}px`,
      marginTop: '-1px',
    };
    const buttonAddedStyle = {
      color: primaryColor,
      backgroundColor: textHeaderColor,
      borderRadius: `${_selectedRadiusOption}px`,
    };

    return (
      <I18nextProvider i18n={i18nData}>
        <div>
          <TitleBubble message={message} title={title} />
          <div
            data-hook="coupon"
            className={styles.couponContainer}
            style={{ color: textHeaderColor, fontFamily }}
          >
            <div
              data-hook="coupon-header-container"
              className={styles.couponContainer}
              style={headerContainerAddedStyle}
            >
              <div data-hook="coupon-header" className={styles.headerTitle}>
                {headerTitle}
              </div>
              <div
                data-hook="coupon-header-subtitle"
                className={styles.headerSubtitle}
              >
                {headerSubtitle}
              </div>
            </div>
            <CouponDivider color={primaryColor} width="220px" height="19px" />
            <div
              data-hook="coupon-text-container"
              className={styles.couponContainer}
              style={textContainerAddedStyle}
            >
              <div data-hook="coupon-text" className={styles.couponText}>
                {text}
              </div>
              <CouponButton
                text={text}
                onHandleCopy={this.handleCopy}
                buttonAddedStyle={buttonAddedStyle}
                didCopied={this.state.didCopied}
              />
            </div>
          </div>
        </div>
      </I18nextProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18nData: state.i18nData,
    primaryColor: primaryColorOrDefault(state),
    textHeaderColor: headerTextColorOrDefault(state),
    selectedRadiusOption: selectedRadiusOption(state),
    fontFamily: messagesFontFamily(state),
  };
}

export default connect(mapStateToProps)(Coupon);
